export var UIMSceneEnum = /*#__PURE__*/ function(UIMSceneEnum) {
    UIMSceneEnum[UIMSceneEnum["Leaderboard"] = 0] = "Leaderboard";
    UIMSceneEnum[UIMSceneEnum["Lobby"] = 1] = "Lobby";
    UIMSceneEnum[UIMSceneEnum["Homepage"] = 2] = "Homepage";
    UIMSceneEnum[UIMSceneEnum["Store"] = 3] = "Store";
    UIMSceneEnum[UIMSceneEnum["More"] = 4] = "More";
    UIMSceneEnum[UIMSceneEnum["Game"] = 5] = "Game";
    return UIMSceneEnum;
}({});
